import React from 'react'

export const CHEVRON_DOWN_VIEWBOX = '0 0 24 22'
export const CHEVRON_DOWN_PATH = 'M6 8.21582L12 13.693L18 8.21582'

interface ChevronDownIconProps extends React.SVGProps<SVGSVGElement> {
    width?: number | string
    height?: number | string
    stroke?: string
}

export const ChevronDownIcon = React.forwardRef<SVGSVGElement, ChevronDownIconProps>(
    ({ width = 24, height = 22, stroke = 'var(--gm-fg-primary-black, #1f1e1d)', ...props }, ref) => (
        <svg
            ref={ref}
            width={width}
            height={height}
            viewBox={CHEVRON_DOWN_VIEWBOX}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d={CHEVRON_DOWN_PATH} stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
)

ChevronDownIcon.displayName = 'ChevronDownIcon'
